import { InjectionToken } from '@angular/core'

type IRow = any

interface IModalConfig {
    row: IRow
    parameters?: any
    readonly?: boolean
}

// Jeton pour transmettre les données arbitraires à l'intérieur de la modale.
export const MODAL_DATA = new InjectionToken<IModalConfig | IRow>('MODAL_DATA')
